module.exports = __webpack_public_path__ + "static/media/success.fbe05383.png";